import React from "react";
import { formatContractValue } from "../../helpers/formatContractValue";

export default function ContractValueBadge({ value }) {
	const label = formatContractValue(value);

	if (label === "—") {
		return <span className="text-sm font-medium text-default-400">—</span>;
	}

	return (
		<span className="inline-flex items-center rounded px-2.5 py-0.5 text-xs font-semibold bg-emerald-500/10 text-emerald-700 dark:text-emerald-400">
			{label}
		</span>
	);
}
